export default __webpack_public_path__ + "static/media/banner.543b2098.gif";